import axios from 'axios';
import qs from 'qs';
import { getSessionStorage, SESSION_NAME } from './storage';
import { VERSION } from "../variable";

const TIME_OUT = 100000;
//const TIME_OUT = 10000;
export const ERR_CODE = {
  timeout: -TIME_OUT,
  notFound: 404,
  networkError: 500
};

/*
  请求头为application/json
*/
const jsonInstance = axios.create({
  timeout: TIME_OUT,
  headers: { 'Content-Type': 'application/json' },
  transformResponse: [
    function(data) {
      return JSON.parse(data);
    }
  ]
});
/*
  普通post请求
*/
const postInstance = axios.create({
  timeout: TIME_OUT,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  transformResponse: [
    function(resp) {
      return JSON.parse(resp);
    }
  ]
});

jsonInstance.interceptors.response.use(
  function(res) {
    let data = res.data || {};
    if (data.code === 40007) {
      let url = window.location.origin + '/#login';
      window.location.replace(url);
    }
    return res;
  },
  function(error) {
    return Promise.reject(error);
  }
);

postInstance.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

postInstance.interceptors.response.use(
  function(res) {
    let data = res.data || {};
    if (data.code === 40007) {
      let url = window.location.origin + '/#login';
      window.location.replace(url);
    }
    return res;
  },
  function(error) {
    // Do something with response error
    console.log('拦截器', error);
    return Promise.reject(error);
  }
);

// 重新包装一下，使得超时的err有response
const errHandler = err => {
  console.dir(err);
  if (err.message === `timeout of ${TIME_OUT}ms exceeded`) {
    const timeOutObj = {
      success: false,
      code: ERR_CODE.timeout,
      msg: '请求超时'
    };
    throw timeOutObj;
  }
  if (err.message === 'Request failed with status code 404') {
    const notFountObj = {
      success: false,
      code: ERR_CODE.notFound,
      msg: '接口404'
    };
    throw notFountObj;
  }
  if (err.message === 'Network Error') {
    const netError = {
      success: false,
      code: ERR_CODE.networkError,
      msg: '网络错误'
    };
    throw netError;
  }
  throw err;
};

/*
  get请求，参数：params
*/
export const get = (url, params, access_token) => {
  const token = access_token || getSessionStorage(SESSION_NAME.token);
  let urlStr = url;
  if (params && Object.keys(params).length > 0) {
    urlStr += `?access_token=${token}&version=${VERSION}&`;
    const notEmptyParams = {};
    for (let i in params) {
      if (params[i] !== 0 && params[i]) {
        notEmptyParams[i] = params[i];
      }
    }
    urlStr += qs.stringify(notEmptyParams);
  } else {
    urlStr += `?access_token=${token}&version=${VERSION}&`;
  }
  return jsonInstance
    .get(urlStr)
    .then(response => response.data)
    .catch(errHandler);
};

/*
  post请求
*/
export const post = (url, params) => {
  const token = getSessionStorage(SESSION_NAME.token);
  const urlStr = `${url}?access_token=${token}&version=${VERSION}`;
  return postInstance
    .post(urlStr, qs.stringify(params))
    .then(response => response.data)
    .catch(errHandler);
};

/*
  登录post请求
*/
export const authPost = (url, params) => {
  return postInstance
    .post(url, qs.stringify(params))
    .then(response => response.data)
    .catch(errHandler);
};

/*
  请求头为application/json的post请求
*/
export const jsonPost = (url, params) => {
  const token = getSessionStorage(SESSION_NAME.token);
  const urlStr = `${url}?access_token=${token}&version=${VERSION}`;
  return jsonInstance
    .post(urlStr, JSON.stringify(params))
    .then(response => response.data)
    .catch(errHandler);
};



// WEBPACK FOOTER //
// ./src/utils/fetch.js